import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-head" }
const _hoisted_2 = {
  key: 0,
  class: "source-logo"
}
const _hoisted_3 = { class: "content-text" }
const _hoisted_4 = {
  key: 0,
  class: "description"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Logo = _resolveComponent("Logo")
  const _component_Image = _resolveComponent("Image")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_SourceType = _resolveComponent("SourceType")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["source", {pointer: $options.can_click}]),
    onClick: _cache[0] || (_cache[0] = $event => ($options.onSourceClick()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.source.logo_url || $props.source.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            ($props.source.type === 'genrate')
              ? (_openBlock(), _createBlock(_component_Logo, {
                  key: 0,
                  size: "1.6rem"
                }))
              : ($props.source.logo_url)
                ? (_openBlock(), _createBlock(_component_Image, {
                    key: 1,
                    class: "image",
                    shape: "square",
                    size: "1.6rem",
                    src: $props.source.logo_url,
                    placeholder: "assets/company-placeholder.png"
                  }, null, 8 /* PROPS */, ["src"]))
                : ($props.source.file_id)
                  ? (_openBlock(), _createBlock(_component_FileIcon, {
                      key: 2,
                      "font-size": "0.5rem",
                      width: "1.7rem",
                      height: "1.8rem",
                      ext: $props.source.name.split('.').pop()
                    }, null, 8 /* PROPS */, ["ext"]))
                  : _createCommentVNode("v-if", true),
            ($props.source.name)
              ? (_openBlock(), _createBlock(_component_Ellipsis, {
                  key: 3,
                  teleported: "",
                  "tooltip-placement": "top-start",
                  "max-width": "29.9rem"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($props.source.name), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_SourceType, {
        type: $props.source.type,
        internal: $props.source.internal
      }, null, 8 /* PROPS */, ["type", "internal"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Ellipsis, {
        teleported: "",
        class: "title",
        "tooltip-placement": "top-start",
        "max-width": "29.9rem"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.source.title), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      ($props.source.summary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Ellipsis, {
              teleported: "",
              "tooltip-placement": "top-start",
              lines: 2,
              "max-width": "29.9rem"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.source.summary), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (_openBlock(), _createBlock(_component_Ellipsis, {
            key: 1,
            teleported: "",
            class: "url",
            "tooltip-placement": "top-start",
            lines: 2,
            "max-width": "29.9rem"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.source.url), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
    ])
  ], 2 /* CLASS */))
}